module.exports = __webpack_public_path__ + "static/welltreadsearch-1e24497670f0fa45e330365c50d745e9.png";